import { Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material';
import { Router } from '@angular/router';

@Component({
  selector: 'meu-app-bottom-table-mobile',
  templateUrl: './app-bottom-table-mobile.component.html',
  styleUrls: ['./app-bottom-table-mobile.component.scss']
})
export class AppBottomTableMobileComponent implements OnInit {

  constructor(
    private router: Router,
    @Inject(MAT_BOTTOM_SHEET_DATA) public lstDocumentShape,
    private appBottomTableMobileComponent: MatBottomSheetRef<AppBottomTableMobileComponent>
  ) {
  }
  displayedColumns: string[] = ['code', 'name'];


  ngOnInit() {
  }
  ngOnDestroy() {
  }
  dismissAppBottom(){
    this.appBottomTableMobileComponent.dismiss()
  }
  selectProduct(productId, seoName) {
    this.router.navigate(['/product/' + productId + '/' + seoName + '/details']);
    this.appBottomTableMobileComponent.dismiss();
  }
  reloadComponent(id) {
    this.appBottomTableMobileComponent.dismiss();
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['/searchbydocument/' + id + '/detail']);

  }
}
